import { render } from "./MainInsuranceAccountsReceivable.vue?vue&type=template&id=7eb5322e&scoped=true"
import script from "./MainInsuranceAccountsReceivable.vue?vue&type=script&lang=js"
export * from "./MainInsuranceAccountsReceivable.vue?vue&type=script&lang=js"

import "./MainInsuranceAccountsReceivable.vue?vue&type=style&index=0&id=7eb5322e&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eb5322e"]])

export default __exports__